import { render, staticRenderFns } from "./emailNotification-dorInterface-grid.vue?vue&type=template&id=3908bb06&"
import script from "./emailNotification-dorInterface-grid.vue?vue&type=script&lang=js&"
export * from "./emailNotification-dorInterface-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports